import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fullWidth?: boolean;
  secondary?: boolean;
}

export function Button(props: ButtonProps) {
  const classNames = [ 'button' ];

  if (props.fullWidth) {
    classNames.push('full-width');
  }

  if (props.secondary) {
    classNames.push('secondary');
  }

  const buttonProps = { ...props };
  
  delete buttonProps.fullWidth;
  delete buttonProps.secondary;

  return (
    <button {...buttonProps} className={classNames.join(' ')}>
      {props.children}
    </button>
  );
}
